import type { Step } from "react-joyride";

export const kpiDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດ KPI! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນທັງໝົດຂອງ KPI ແລະການມອບໝາຍທີ່ກ່ຽວຂ້ອງ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດກັບໄປຫນ້າລາຍການ KPI ດ້ວຍປຸ່ມ 'ກັບ', ສົ່ງອອກ PDF ດ້ວຍປຸ່ມ 'ສົ່ງອອກ PDF', ຫຼືແກ້ໄຂ KPI ນີ້ດ້ວຍປຸ່ມ 'ແກ້ໄຂ' (ຖ້າທ່ານມີສິດແກ້ໄຂ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານຂອງ KPI. ທ່ານຈະເຫັນຊື່, ຄຳອະທິບາຍ, ລະດັບ (ພະນັກງານ/ພະແນກກ/ອົງກອນ), ແລະສະຖານະ (ກຳລັງໃຊ້ງານ/ຮ່າງ/ປິດການໃຊ້ງານ) ຂອງ KPI ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-measurement"]',
    content:
      "ນີ້ແມ່ນພາກວິທີການວັດ. ທ່ານຈະເຫັນວິທີການນັບ (ນັບຢ່າງໃດ), ແຫຼ່ງຂໍ້ມູນ (ວັດຈາກຫຍັງ), ແລະຮອບການວັດ (ເດືອນ/ໄຕມາດ/ປີ) ຂອງ KPI ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-target"]',
    content:
      "ນີ້ແມ່ນພາກເປົ້າໝາຍ ແລະ ເກນການປະເມີນ. ທ່ານຈະເຫັນຄ່າເປົ້າໝາຍ, ເກນຜ່ານ (ຕົວຢ່າງ: >= 80%), ແລະເກນບໍ່ຜ່ານ (ຕົວຢ່າງ: < 60%) ຂອງ KPI ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-notes"]',
    content:
      "ນີ້ແມ່ນພາກໝາຍເຫດ (ຖ້າມີ). ທ່ານຈະເຫັນຂໍ້ຄວາມເຕືອນ, ສິ່ງທີ່ບໍ່ເອົາມານັບ, ຫຼືຂໍ້ມູນເພີ່ມເຕີມກ່ຽວກັບ KPI ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-assignment-stats"]',
    content:
      "ນີ້ແມ່ນສະຖິຕິການມອບໝາຍ. ທ່ານຈະເຫັນຈຳນວນການມອບໝາຍທັງໝົດ, ຈຳນວນທີ່ກຳລັງໃຊ້ງານ, ຈຳນວນພະນັກງານທີ່ໄດ້ຮັບການມອບໝາຍ, ແລະຈຳນວນຕໍາແໜ່ງ/ພະແນກກທີ່ໄດ້ຮັບການມອບໝາຍ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-assignments"]',
    content:
      "ນີ້ແມ່ນພາກການມອບໝາຍ. ທ່ານສາມາດເບິ່ງ, ເພີ່ມ, ແກ້ໄຂ, ຫຼືລຶບການມອບໝາຍ KPI ນີ້ກັບພະນັກງານ, ຕໍາແໜ່ງ, ຫຼືພະແນກກ. ການມອບໝາຍຈະກຳນົດວ່າໃຜຕ້ອງວັດ KPI ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-additional-info"]',
    content: "ນີ້ແມ່ນພາກຂໍ້ມູນອື່ນໆ. ທ່ານຈະເຫັນວັນທີສ້າງແລະວັນທີແກ້ໄຂລ່າສຸດຂອງ KPI ນີ້.",
    placement: "top",
  },
];
